import { render, staticRenderFns } from "./FuInputRwSwitch.vue?vue&type=template&id=61c7b692&"
import script from "./FuInputRwSwitch.vue?vue&type=script&lang=js&"
export * from "./FuInputRwSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports